import { render, staticRenderFns } from "./InventoryTableShow.vue?vue&type=template&id=37230c6c&scoped=true"
import script from "./InventoryTableShow.vue?vue&type=script&lang=js"
export * from "./InventoryTableShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37230c6c",
  null
  
)

export default component.exports